<template>
  <generic-modal
    size="large"
    :title="$t('course assignation season')"
    icon="graduation"
    image="/images/icons/course_assignation.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <h3 class="ui dividing header">{{ $t("basic information") }}</h3>
        <div class="fields">
          <div class="four column wide field">
            <label for>{{ $t("name") }}</label>
            <input type="text" name="name" v-model="season.name" />
          </div>
          <div class="four column wide field">
            <label>{{ $t("start date") }}</label>
            <div class="ui calendar" ref="range_start">
              <div class="ui input left icon">
                <i class="calendar icon"></i>
                <input type="text" :placeholder="$t('start date')" />
              </div>
            </div>
          </div>
          <div class="four column wide field">
            <label>{{ $t("end date") }}</label>
            <div class="ui calendar" ref="range_end">
              <div class="ui input left icon">
                <i class="calendar icon"></i>
                <input type="text" :placeholder="$t('end date')" />
              </div>
            </div>
          </div>
          <div class="four column wide field">
            <label for>{{ $t("is default") }}</label>
            <div class="ui toggle checkbox">
              <input
                type="checkbox"
                name="example"
                v-model="season.is_default"
              />
              <label>{{ $t("is default season?") }}</label>
            </div>
          </div>
        </div>
        <!-- <div class="ui two item pointing secondary menu" ref="tabs">
          <a class="item active" data-tab="general">
            <i class="info circle icon"></i>
            {{ $t("general information") }}
          </a>
          <a class="item" data-tab="courses">
            <i class="book icon"></i>
            {{ $t("courses") }}
          </a>
        </div> -->
        <!-- <div class="ui tab segment active" data-tab="general">
          <general
            :season_in="season"
            :configuration="configuration"
            ref="general"
          />
        </div> -->
        <!-- <div class="ui tab segment" data-tab="courses"> -->
        <!-- <courses
          :season_in="season"
          :configuration="configuration"
          ref="courses"
        /> -->
        <!-- </div> -->
        <div class="ui error message"></div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import { cloneDeep, isEmpty } from "lodash";
import GenericModal from "@/components/GenericModal";
// import General from "./General";
// import Courses from "./Courses";

export default {
  name: "CourseAssignationModalIndex",
  components: {
    "generic-modal": GenericModal,
    // General,
    // Courses,
  },
  computed: {},
  props: { assignation_in: Object },
  data() {
    return {
      season: {
        uuid: undefined,
        start_date: "",
        end_date: "",
        is_default: true,
        name: "",
        setup: {
          // general: [],
          courses: [],
        },
      },
      configuration: { assignation_configuration: {} },
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let isValid = window.jQuery(vm.$refs.form).form("validate form");

        if (!isValid) reject();
        else {
          let crs = cloneDeep(vm.season);
          // let _setup = crs.setup;

          // _setup.general = vm.$refs.general ? vm.$refs.general.getList() : [];
          // _setup.general = vm.$refs.general ? vm.$refs.general.getData() : {};
          // _setup.courses = vm.$refs.courses ? vm.$refs.courses.getList() : [];

          local_api(vm, "post", "/course/assignation/do-save-season", {
            c: crs,
          })
            .then((product) => {
              vm.$emit("succedded", product);
              resolve();
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    },
    destroy() {
      this.$emit("destroy");
      // this.$destroy();
    },
  },
  created() {},
  mounted() {
    let vm = this;
    local_api(this, "post", "/course/assignation/do-get-configuration")
      .then((conf) => {
        if (conf && conf.conf) {
          vm.configuration = conf;

          setTimeout(() => {
            // vm.$refs.general.update();
            // vm.$refs.courses.update();
          }, 1000);
        }
      })
      .catch((err) => {
        error_toast(err);
      });
    if (!isEmpty(vm.course_in)) {
      vm.course = cloneDeep(vm.course_in);
    }

    window.jQuery(vm.$refs.form).form({
      fields: {
        name: ["empty"],
      },
    });

    setTimeout(() => {
      if (vm.assignation_in && vm.assignation_in.uuid) {
        vm.season = vm.assignation_in;

        if (vm.season.start_date) {
          window
            .jQuery(vm.$refs.range_start)
            .calendar("set date", vm.season.start_date);
        }
        if (vm.season.end_date) {
          window
            .jQuery(vm.$refs.range_end)
            .calendar("set date", vm.season.end_date);
        }
      }
    }, 300);

    window
      .jQuery(vm.$refs.tabs)
      .find(".item")
      .tab();

    window.jQuery(vm.$refs.range_start).calendar({
      today: true,
      type: "date",
      endCalendar: window.jQuery(vm.$refs.range_end),
      onSelect(value) {
        vm.season.start_date = value;
      },
    });
    window.jQuery(vm.$refs.range_end).calendar({
      today: true,
      type: "date",
      startCalendar: window.jQuery(vm.$refs.range_start),
      onSelect(value) {
        vm.season.end_date = value;
      },
    });
  },
  watch: {},
  updated: function() {},
};
</script>
